import { render, staticRenderFns } from "./WorksTableLite.vue?vue&type=template&id=c94fb166&"
import script from "./WorksTableLite.vue?vue&type=script&lang=js&"
export * from "./WorksTableLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports